const attemptedScopes = new Set<string>();

export function shouldAutoClaimChatLock(
    scope: {tenant: string; userId: string},
    visibilityState: DocumentVisibilityState,
    attempted: Set<string> = attemptedScopes,
): boolean {
    const key = `${scope.tenant}:${scope.userId}`;
    if (attempted.has(key)) return false;

    attempted.add(key);
    return visibilityState === 'visible';
}

export function markChatLockAutoClaimSpent(
    scope: {tenant: string; userId: string},
    attempted: Set<string> = attemptedScopes,
): void {
    attempted.add(`${scope.tenant}:${scope.userId}`);
}
